(() => {
  const initializeHeroSwitch = (root) => {
    const overlay = root.querySelector('[data-bb-hero-switch-overlay]');
    if (!overlay || overlay.dataset.bbHeroSwitchReady === 'true') return;

    const triggers = Array.from(overlay.querySelectorAll('[data-bb-hero-switch-trigger]'));
    if (!triggers.length) return;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    triggers.forEach((trigger) => {
      trigger.addEventListener('click', (event) => {
        const modifiedClick = event.metaKey || event.ctrlKey || event.shiftKey || event.altKey;
        if (event.button !== 0 || modifiedClick) return;

        event.preventDefault();
        if (trigger.classList.contains('is-switching')) return;

        trigger.classList.add('is-on', 'is-switching');
        window.setTimeout(() => window.location.assign(trigger.href), reducedMotion.matches ? 80 : 360);
      });
    });

    overlay.dataset.bbHeroSwitchReady = 'true';
  };

  const initialize = (scope = document) => {
    scope.querySelectorAll('.bb-editorial-home').forEach(initializeHeroSwitch);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  window.addEventListener('pageshow', () => {
    document.querySelectorAll('[data-bb-hero-switch-trigger]').forEach((trigger) => {
      trigger.classList.remove('is-on', 'is-switching');
    });
  });
})();
